
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solution-for-institutional-buyers",
      function () {
        return require("private-next-pages/solution-for-institutional-buyers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solution-for-institutional-buyers"])
      });
    }
  